import type { HeaderIcon } from "@/types/artifacts.ts";
import type {
  ArtifactLibraryArtifactItem,
  ArtifactLibrarySharedItem,
} from "@/types/artifactLibrary.ts";
import { artifactDisplayTitle } from "./artifactTitle.ts";

/**
 * Anything the Library names and draws chrome for: an artifact of the viewer's
 * own, or one another account has shared with them. The shared payload is a
 * redacted artifact, so both carry the chrome fields below.
 */
type RowArtifact = ArtifactLibraryArtifactItem | ArtifactLibrarySharedItem;

/**
 * The chrome an Artifact Library row/card shows for an artifact result, shared
 * by web's Library panel and native's Library screen so the same artifact reads
 * identically on both.
 *
 * The chrome fields a row/card shows (type title, status label, icon). Every
 * Library artifact is "heavy" and carries these; the guard keeps TypeScript
 * happy against the full (heavy | light) response union.
 */
export const artifactRowMeta = (
  item: RowArtifact,
): { typeTitle: string; statusLabel: string; iconName: HeaderIcon | undefined } => {
  if ("artifactTypeTitle" in item) {
    return {
      typeTitle: item.artifactTypeTitle,
      statusLabel: item.statusLabel,
      iconName: item.iconName,
    };
  }
  return { typeTitle: "Item", statusLabel: "", iconName: undefined };
};

/**
 * The primary label for an artifact row/card. Delegates to the shared
 * `artifactDisplayTitle` so a Library row and the header of the artifact it
 * opens always agree on the name.
 */
export const artifactRowTitle = (item: RowArtifact): string => artifactDisplayTitle(item);
